import React from 'react';
import LegalLayout, { Section } from './LegalLayout';

/**
 * Datenschutzerklärung für das interne Agentur-Tool (AgencyOS / TGOSM).
 * HINWEIS: Firmen-/Kontaktangaben ggf. an den tatsächlichen Stand anpassen.
 */
export default function DatenschutzPage() {
    return (
        <LegalLayout title="Datenschutzerklärung" updated="August 2026">
            <p>
                Diese Datenschutzerklärung informiert über die Verarbeitung personenbezogener Daten bei der
                Nutzung der internen Arbeitsplattform „AgencyOS“ (nachfolgend „die Plattform“). Die Plattform
                ist ein internes Werkzeug und richtet sich ausschließlich an Mitarbeiterinnen und Mitarbeiter
                sowie beauftragte Talente („Social Faces“) des Betreibers.
            </p>

            <Section heading="1. Verantwortlicher">
                <p>
                    The Guardians of Social Media GmbH<br />
                    Mahlerstraße 7/34, 1010 Wien, Österreich<br />
                    E-Mail: datenschutz@theguardians.at
                </p>
                <p className="text-xs">
                    (Bitte Kontaktangaben bei Bedarf anpassen.)
                </p>
            </Section>

            <Section heading="2. Zweck der Verarbeitung">
                <p>
                    Die Plattform dient der internen Organisation der Agenturarbeit: Aufgaben- und
                    Projektverwaltung, Zeiterfassung, Kalender, Kunden- und Content-Planung, Team-Kommunikation
                    sowie der Abrechnung von Honorarleistungen. Eine Nutzung ist nur nach vorheriger
                    Freischaltung durch den Betreiber möglich; es findet keine öffentliche Registrierung statt.
                </p>
            </Section>

            <Section heading="3. Verarbeitete Daten">
                <ul className="list-disc pl-5 space-y-1">
                    <li>Stammdaten der Nutzer (Name, E-Mail-Adresse, Rolle, ggf. Telefonnummer)</li>
                    <li>Anmelde- und Nutzungsdaten (Login-Zeitpunkte, Aktivitätsprotokolle)</li>
                    <li>Bei Anmeldung über Google: die von Google übermittelte E-Mail-Adresse, der Name und das Profilbild – ausschließlich zur Zuordnung zu einem bestehenden Konto</li>
                    <li>Arbeitsbezogene Inhalte (Aufgaben, Projekte, Kalendereinträge, Zeiteinträge, Nachrichten, hochgeladene Dateien)</li>
                    <li>Bei „Social Faces“ zusätzlich Abrechnungsdaten (Adresse, IBAN/BIC) zur Erstellung von Honorarnoten</li>
                </ul>
            </Section>

            <Section heading="4. Anmeldung über Google (Google Sign-In)">
                <p>
                    Für die Anmeldung kann optional „Anmelden mit Google“ verwendet werden. Dabei wird die
                    Google-Identität geprüft und ausschließlich die E-Mail-Adresse mit einem bereits im System
                    hinterlegten Konto abgeglichen. Es werden keine Kontakte, Kalender oder sonstigen
                    Google-Daten abgerufen. Die Nutzung von Google-Diensten unterliegt zusätzlich der
                    Datenschutzerklärung von Google.
                </p>
            </Section>

            <Section heading="5. Eingesetzte Dienstleister (Auftragsverarbeiter)">
                <ul className="list-disc pl-5 space-y-1">
                    <li>Hosting und Datenbank: Railway (Betrieb der Anwendung)</li>
                    <li>Datei-Speicher: Cloudflare R2 bzw. Railway-Objektspeicher (hochgeladene Dateien und Bilder)</li>
                    <li>E-Mail-Versand: Resend (transaktionale E-Mails wie Benachrichtigungen und Login-Links)</li>
                    <li>KI-Assistent und Sprach-Transkription: OpenAI (Verarbeitung der jeweils eingegebenen Anfrage)</li>
                    <li>Anmeldung: Google (optionaler Login)</li>
                </ul>
                <p>
                    Mit diesen Anbietern bestehen die datenschutzrechtlich erforderlichen Vereinbarungen. Eine
                    Verarbeitung erfolgt nur im zur Bereitstellung der Plattform notwendigen Umfang.
                </p>
            </Section>

            <Section heading="6. Rechtsgrundlage">
                <p>
                    Die Verarbeitung erfolgt zur Erfüllung des Beschäftigungs- bzw. Auftragsverhältnisses und
                    auf Grundlage des berechtigten Interesses des Betreibers am ordnungsgemäßen Betrieb der
                    internen Arbeitsorganisation (Art. 6 Abs. 1 lit. b und f DSGVO).
                </p>
            </Section>

            <Section heading="7. Speicherdauer">
                <p>
                    Personenbezogene Daten werden nur so lange gespeichert, wie es für den genannten Zweck oder
                    aufgrund gesetzlicher Aufbewahrungspflichten (z. B. bei Abrechnungsdaten) erforderlich ist.
                </p>
            </Section>

            <Section heading="8. Ihre Rechte">
                <p>
                    Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
                    Datenübertragbarkeit und Widerspruch. Wenden Sie sich hierzu an den oben genannten
                    Verantwortlichen. Zudem besteht ein Beschwerderecht bei der Datenschutzbehörde.
                </p>
            </Section>

            <Section heading="9. Kontakt">
                <p>
                    Bei Fragen zum Datenschutz erreichen Sie uns unter: datenschutz@theguardians.at
                </p>
            </Section>
        </LegalLayout>
    );
}
